"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandlers = exports.useHelperProps = exports.useTimeValue = exports.usePopup = exports.useValueUpdater = exports.useCalendarValue = exports.useInputValue = void 0;
var react_1 = require("react");
var system_1 = require("../../system");
var dateTime_1 = require("../../utils/dateTime");
var utils_1 = require("./utils");
function useInputValue(value, inputDateFormat, dateFormat) {
    var outerValue = (0, utils_1.formatInput)(value, inputDateFormat, dateFormat);
    var _a = __read((0, react_1.useState)(outerValue), 2), inputValue = _a[0], setInputValue = _a[1];
    var isValidInputFormat = (0, react_1.useMemo)(function () { return (0, dateTime_1.isValidDate)(inputValue, inputDateFormat); }, [inputValue, inputDateFormat]);
    // хедлим изенение данных кодом в обход пикера
    (0, react_1.useEffect)(function () {
        if (outerValue !== inputValue) {
            // console.log('INPUT FORCE CHANGED');
            setInputValue(outerValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [outerValue]);
    return [inputValue, setInputValue, isValidInputFormat];
}
exports.useInputValue = useInputValue;
function useCalendarValue(_a) {
    var value = _a.value, dateFormat = _a.dateFormat;
    var outerValue = (0, dateTime_1.isValidDate)(value, dateFormat)
        ? (0, dateTime_1.toISO)(value, dateFormat)
        : (0, dateTime_1.isValidDate)(value)
            ? (0, dateTime_1.toISO)(value)
            : undefined;
    if (outerValue) {
        // чтобы не реагировать на изменение времени
        outerValue = (0, dateTime_1.setTime)(outerValue, '00:00');
    }
    var _b = __read((0, react_1.useState)(outerValue), 2), calendarValue = _b[0], setCalendarValue = _b[1];
    // хедлим изенение данных кодом в обход пикера
    (0, react_1.useEffect)(function () {
        if (outerValue !== calendarValue) {
            // console.log('CALENDAR FORCE CHANGED');
            setCalendarValue(outerValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [outerValue]);
    return [calendarValue, setCalendarValue];
}
exports.useCalendarValue = useCalendarValue;
function useValueUpdater(_a) {
    var value = _a.value, inputValue = _a.inputValue, inputDateFormat = _a.inputDateFormat, dateFormat = _a.dateFormat, withTime = _a.withTime, timeInputValue = _a.timeInputValue, setCalendarValue = _a.setCalendarValue, onChange = _a.onChange;
    return (0, react_1.useCallback)(function (_a) {
        var _b = _a.newInputValue, newInputValue = _b === void 0 ? inputValue : _b, _c = _a.newTimeValue, newTimeValue = _c === void 0 ? timeInputValue : _c;
        if ((0, dateTime_1.isValidDate)(newInputValue, inputDateFormat)) {
            setCalendarValue((0, dateTime_1.toISO)(newInputValue, inputDateFormat));
            var finalDate = (0, dateTime_1.replaceFormat)(newInputValue, inputDateFormat, dateFormat);
            if (withTime && newTimeValue) {
                finalDate = (0, dateTime_1.setTime)(finalDate, newTimeValue, dateFormat, (0, dateTime_1.getTime)(value));
            }
            if (!(0, dateTime_1.isSame)(finalDate, value, withTime ? 'minute' : 'day')) {
                return onChange === null || onChange === void 0 ? void 0 : onChange(finalDate);
            }
        }
    }, [
        inputValue,
        inputDateFormat,
        dateFormat,
        onChange,
        timeInputValue,
        withTime,
        value,
        setCalendarValue,
    ]);
}
exports.useValueUpdater = useValueUpdater;
function usePopup() {
    var inputRef = (0, react_1.useRef)();
    var paperRef = (0, react_1.useRef)();
    var _a = __read((0, react_1.useState)(null), 2), anchorEl = _a[0], setAnchorEl = _a[1];
    (0, react_1.useEffect)(function () {
        if (inputRef.current) {
            setAnchorEl(inputRef.current);
        }
    }, []);
    return [inputRef, paperRef, anchorEl];
}
exports.usePopup = usePopup;
function useTimeValue(value, withTime) {
    var outerValue = (0, dateTime_1.getTime)(value);
    var _a = __read((0, react_1.useState)(outerValue), 2), timeInputValue = _a[0], setTimeInputValue = _a[1];
    // хедлим изенение данных кодом в обход пикера
    (0, react_1.useEffect)(function () {
        if (withTime && outerValue !== timeInputValue) {
            // console.log('TIME FORCE CHANGED');
            setTimeInputValue(outerValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [outerValue]);
    return [timeInputValue, setTimeInputValue];
}
exports.useTimeValue = useTimeValue;
var useHelperStyles = (0, system_1.makeStyles)(function () { return ({
    root: {
        width: 'calc(100% + 63px)',
    },
}); });
function useHelperProps(withTime) {
    var styles = useHelperStyles();
    return (0, react_1.useMemo)(function () {
        return withTime
            ? {
                classes: styles,
            }
            : undefined;
    }, [withTime, styles]);
}
exports.useHelperProps = useHelperProps;
function useHandlers(_a) {
    var setInputValue = _a.setInputValue, setTimeInputValue = _a.setTimeInputValue, setCalendarValue = _a.setCalendarValue, onChange = _a.onChange, updater = _a.updater, inputDateFormat = _a.inputDateFormat;
    var onClear = (0, react_1.useCallback)(function () {
        setInputValue('');
        setTimeInputValue('');
        setCalendarValue(undefined);
        return onChange === null || onChange === void 0 ? void 0 : onChange('');
    }, [onChange, setInputValue, setTimeInputValue, setCalendarValue]);
    var onDateChange = (0, react_1.useCallback)(function (date) {
        var newInputValue = (0, dateTime_1.formatDate)(date, inputDateFormat);
        setInputValue === null || setInputValue === void 0 ? void 0 : setInputValue(newInputValue);
        updater({ newInputValue: newInputValue });
    }, [inputDateFormat, setInputValue, updater]);
    var onInputValueChange = (0, react_1.useCallback)(function (e) {
        var newInputValue = e.currentTarget.value;
        setInputValue === null || setInputValue === void 0 ? void 0 : setInputValue(newInputValue);
        updater({ newInputValue: newInputValue });
    }, [setInputValue, updater]);
    var onTimeInputValueChange = (0, react_1.useCallback)(function (e) {
        var newTimeValue = e.currentTarget.value;
        setTimeInputValue === null || setTimeInputValue === void 0 ? void 0 : setTimeInputValue(newTimeValue);
        updater({ newTimeValue: newTimeValue });
    }, [setTimeInputValue, updater]);
    return [onClear, onDateChange, onInputValueChange, onTimeInputValueChange];
}
exports.useHandlers = useHandlers;
